import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eye, Loader2 } from "lucide-react";
import { api } from "../lib/api";

const OPTIONS = [
  { value: null, label: "Super Admin", hint: "nessun limite" },
  { value: "free", label: "Piano gratuito", hint: "3 preventivi al mese, filigrana" },
  { value: "beta", label: "Beta Tester", hint: "recensione dopo 5 preventivi" },
  { value: "pro", label: "Pro mensile", hint: "cosa vede chi paga" },
];

export default function ViewAsSwitch() {
  const [current, setCurrent] = useState(undefined);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/billing/status").then(({ data }) => setCurrent(data.view_as || null)).catch(() => {});
  }, []);

  const choose = async (plan) => {
    if (plan === current) return;
    setBusy(true);
    try {
      await api.put("/super-admin/view-as", { plan });
      toast.success(plan ? "Modalità \"Vedi come utente\" attivata" : "Sei tornato Super Admin");
      setTimeout(() => window.location.reload(), 600);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Operazione non riuscita");
      setBusy(false);
    }
  };

  return (
    <div data-testid="view-as-switch" className="mb-8 rounded-xl border border-slate-200 bg-card p-4">
      <p className="font-semibold text-slate-900 flex items-center gap-1.5 mb-1">
        <Eye style={{ width: 16, height: 16 }} /> Vedi come utente {busy && <Loader2 className="w-4 h-4 animate-spin" />}
      </p>
      <p className="text-xs text-slate-500 mb-3">Prova l'app con le stesse regole di un utente. Il conteggio parte da zero a ogni attivazione; pagamenti e recensioni non vengono registrati.</p>
      <div className="flex flex-wrap gap-2">
        {OPTIONS.map((o) => (
          <button key={o.label} type="button" disabled={busy || current === undefined} onClick={() => choose(o.value)}
            data-testid={`view-as-${o.value || "admin"}`}
            className={`rounded-lg border px-3 py-2 text-left text-sm transition-colors ${current === o.value ? "border-primary bg-primary/10 text-primary" : "border-slate-200 hover:bg-slate-50"}`}>
            <span className="font-semibold block">{o.label}</span>
            <span className="text-xs text-slate-500">{o.hint}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export function ViewAsBanner() {
  const [plan, setPlan] = useState(null);
  useEffect(() => {
    api.get("/billing/status").then(({ data }) => setPlan(data.view_as || null)).catch(() => {});
  }, []);
  if (!plan) return null;
  const exit = async () => {
    await api.put("/super-admin/view-as", { plan: null }).catch(() => {});
    window.location.assign("/super-admin");
  };
  return (
    <div data-testid="view-as-banner" className="mb-4 rounded-lg bg-slate-900 text-white px-4 py-2 text-sm flex flex-wrap items-center gap-2">
      <Eye style={{ width: 16, height: 16 }} />
      <span>Stai vedendo l'app come utente <strong>{{ beta: "Beta Tester", pro: "Pro mensile" }[plan] || "Piano gratuito"}</strong>.</span>
      <button type="button" data-testid="view-as-exit-btn" onClick={exit} className="font-semibold underline">Torna Super Admin</button>
    </div>
  );
}
